import Image from 'next/legacy/image';
import Link from 'next/link';
import React, {ReactElement} from 'react';

import Col from '../../common/Col';
import {useBreakpoint} from '../../common/util/useBreakpoint';
import {CMSMedia} from '../../strapi/types';

type Props = {
  title: string;
  partners: {url?: string; logo: CMSMedia[]}[];
};

const COLLAB_IMG_MOBILE_SCALE_FACTOR = 0.5;

const PartnerLogos = ({title, partners}: Props): ReactElement => {
  const {isMobile} = useBreakpoint('mobile');

  return (
    <Col className={'gap-lg'}>
      <div className="text-3xl font-semibold leading-tight">{title}</div>
      <div className="flex flex-row mobile:flex-wrap gap-x-24 mobile:gap-9 items-center justify-center">
        {partners.map((ci, idx) => {
          const media = ci.logo[0];
          const image = isMobile
            ? {
                ...media,
                width: (media.width ?? 0) * COLLAB_IMG_MOBILE_SCALE_FACTOR,
                height: (media.height ?? 0) * COLLAB_IMG_MOBILE_SCALE_FACTOR,
              }
            : media;
          return (
            <Link key={`ci-${idx}`} href={ci.url || ''} target={'_blank'} rel={'noopener noreferrer'}>
              <Image src={image.src} alt={image.alt} height={image.height} width={image.width} />
            </Link>
          );
        })}
      </div>
    </Col>
  );
};

export default PartnerLogos;
